<div class="modal-header">
  <h5 class="modal-title">
    <i class="material-icons"></i>
    <strong>&nbsp;{{(accountHeadToEdit)?accountHeadToEdit.name:'Add Account Head'}} </strong>
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="clear()">
    
  </button>
</div>
<form role="form" [formGroup]="accountHeadAddForm" novalidate>
  <div class="modal-body ol-lg-12">
    <div class="col-md-12 ">
      <div class="row">
        <div class="col-md-12 ">
          <fieldset>
            <div class="mb-3 row" *ngIf="!!accountHeadWithTitles?.length">
              <label for="accountTypeId" class="col-4 col-form-label required">{{'Account'|translate}}
                {{'Type'|translate}}</label>
              <div class="col-8"
                [ngClass]="{ 'has-danger' : (submitted &&   accountHeadAddForm.get('accountTypeId').invalid) }">
                <app-auto-suggest [isDisable]="!!accountHeadToEdit" tabindex="2" formControlName="accountTypeId"
                  [isGroup]="true" [optionsGroup]="accountHeadWithTitles" required>
                </app-auto-suggest>
                <show-errors class="text-danger" *ngIf="submitted" [control]="accountHeadAddForm.get('accountTypeId')"
                  [field]="'Account Type'"></show-errors>
              </div>
            </div>
          </fieldset>

          <fieldset>
            <div class="mb-3 row" #parent>
              <label for="name" class="col-4 col-form-label required">{{'Account'|translate}}
                {{'Name'|translate}}</label>
              <div class="col-8" [ngClass]="{ 'has-danger' : (submitted && accountHeadAddForm.get('name').invalid) }">
                <indic-input type="text" tabindex="-1" [parentEl]="parent" tabindex="2" formControlName="name" required>
                  <show-errors class="text-danger" *ngIf="submitted" [control]="accountHeadAddForm.get('name')"
                    [field]="'Account Name'"></show-errors>
                </indic-input>
              </div>
            </div>
          </fieldset>

          <fieldset>
            <div class="mb-3 row">
              <label for="displayOrder" class="col-4 col-form-label">{{'Display'|translate}} {{'Order'|translate}}</label>
              <div class="col-8">
                <input type="number" class="form-control form-control-sm" id="displayOrder" formControlName="displayOrder" placeholder="0">
                <small class="form-text text-muted">
                  {{'Report display order (1, 2, 3... 0 or blank defaults to end)'|translate}}
                </small>
              </div>
            </div>
          </fieldset>

          <fieldset>
            <div class="mb-3 row">
              <label for="isParent" class="col-4 col-form-label required">&nbsp;</label>
              <div class="col-8"
                [ngClass]="{ 'has-danger' : (submitted && accountHeadAddForm.get('isParent').invalid) }">
                <app-checkbox labelName="Make this a sub-account" formControlName="isParent"
                  [formControl]="accountHeadAddForm.get('isParent')" (click)="$event.stopPropagation()"></app-checkbox>
              </div>
            </div>
          </fieldset>
          <fieldset *ngIf="accountHeadAddForm.get('isParent').value===true">
            <div class="mb-3 row">
              <label for="parentAccount" class="col-4 col-form-label required">{{'Parent'|translate}}
                {{'Account'|translate}}</label>
              <div class="col-8"
                [ngClass]="{'has-danger':(submitted && accountHeadAddForm.get('parentAccount').invalid)}">
                <input type="hidden" tabindex="-1" class="form-control form-control-sm" formControlName="id">
                <app-auto-suggest tabindex="2" formControlName="parentId" [isGroup]="true"
                  [optionsGroup]="accountParentHeadWithTitles" required>
                </app-auto-suggest>
                <show-errors class="text-danger" *ngIf="submitted" [control]=" accountHeadAddForm.get('parentAccount')"
                  [field]="'Parent Account'"></show-errors>
              </div>
            </div>
          </fieldset>

          <fieldset *ngIf="accountHeadAddForm.get('accountTypeId').value===6">
            <div class="mb-3 row">
              <label for="bank" class="col-4 col-form-label">&nbsp;</label>
              <div class="col-8" [ngClass]="{ 'has-danger' : (submitted &&  accountHeadAddForm.get('bank').invalid) }">
                <app-checkbox labelName="Is Bank" formControlName="bank" (click)="$event.stopPropagation()"
                  [formControl]="accountHeadAddForm.get('bank')"></app-checkbox>
              </div>
            </div>
          </fieldset>
          <fieldset *ngIf="accountHeadAddForm.get('bank').value===true">
            <div class="mb-3 row">
              <label for="accountNumber" class="col-4 col-form-label required">{{'Account'|translate}}
                {{'Number'|translate}}</label>
              <div class="col-8"
                [ngClass]="{'has-danger':(submitted && accountHeadAddForm.get('accountNumber').invalid)}">
                <input type="hidden" tabindex="-1" class="form-control form-control-sm" formControlName="id">
                <input type="text" class="form-control form-control-sm" formControlName="accountNumber" tabindex="-1"
                  id="AccountNumber" required>
                <show-errors class="text-danger" *ngIf="submitted" [control]=" accountHeadAddForm.get('accountNumber')"
                  [field]="'Account Number'"></show-errors>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <button type="button" class="btn btn-outline-secondary btn-sm col" (click)="clear()">{{'Cancel'|translate}}</button>
      <button type="button" class="btn  btn-success btn-sm col"
        (click)="saveHead()">{{(accountHeadToEdit)?'Update':'Submit'}}</button>
    </div>
  </div>
</form>